<template>
	<div>
        <div class="row">
            <div class="col-md-12 mb-2">
				<h4>PETTY CASH REPORT</h4>
			</div>

			<div class="col-md-12">
                <el-card class="box-card col-md-12 mb-4" shadow="never" :body-style="{ paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px' }">
                    <div slot="header" class="clearfix" v-if="false">
                        <h4>PETTY CASH REPORT</h4>
                    </div>
                    <div>
                        <el-tabs v-model="tabIndex" @tab-click="handleTabClick">
                            <el-tab-pane :label="'Petty Cash'" :name="'0'">
                                <Report :tabIndex="'0'" :tabName="'report_detail'" :tabLabel="'Petty Cash'"/>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>


<script>
import Finance from '@/components/page/Finance.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import Report from '@/views/pages/Finance/PettyCash/Report/PettyCashReportTab.vue'

export default
{
	extends: Finance,
	components: { 
        Report,
	},

	data(){
		return {
            tabIndex : '0',
            urlRequestParams: '',
            reportdata: [],
            stationid: '',
            plant: '',
            spbu: {
                list:[],
            },
			options: {

            },
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
        }
    },

    watch: {

    }, 

    computed: {
        
    },

    mounted() {
        this.$emit('childrenRoute');
    },

    methods: { 

        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
        },

        getData() {

        },

        applyFilter() {
            this.getData()
        },
    }
        
}

</script>